import { AxiosError } from 'axios';
import { AuthStatusCode, HTTPStatusCode } from './enums';

export type BackendServiceErrorResponse<T = string> = Partial<{
  error: T;
  code: T;
  accountStatusCode: AuthStatusCode;
  error_message: string;
  message: string;
  error_code: `${HTTPStatusCode}`;
}>;

export type BackendServiceAxiosError<T = string> = AxiosError<BackendServiceErrorResponse<T>>;

export type SentryError = Error & {
  message: string;
  config: {
    url: string;
    method: string;
    params: Record<string, string>;
    data: unknown;
  };
  request?: Record<string, unknown>;
  response?: {
    status: number;
    statusText: string;
    data: {
      traceId?: string;
    };
  };
};
